import React from 'react';
import { createPortal } from 'react-dom';
import { Button, ButtonColor, IconType, useListContext } from 'ui-builder';
import { usePopupFormManager } from 'features/nekst-widgets';
import { ProjectPermission, withAccessCheck } from 'authorization-scope';
import { ProjectDocument } from 'nekst-api';
import { AddLabelsForm } from 'features/tasks-forms';

export function AddLabelsButtonPortal() {
  return <span id="add-labels-button" />;
}

function AddLabelsButton(props: {
  projectId: number
}) {

  const listContext = useListContext<ProjectDocument>();

  const usedLabelsIds = listContext.data?.filter((item) => item.labelId)
    .map((item) => item.labelId!) || [];

  const popupManager = usePopupFormManager();

  const portal = document.getElementById('add-labels-button');

  if (portal) {
    return createPortal(
      <Button
        text="Add Labels"
        iconType={IconType.PLUS}
        color={ButtonColor.BLUE}
        onClick={() => {
          popupManager.openForm(
            <AddLabelsForm
              projectId={props.projectId}
              usedLabelsIds={usedLabelsIds}
            />,
          );
        }}
      />,
      portal,
    );
  } else {
    return null;
  }
}

export default withAccessCheck(AddLabelsButton, ProjectPermission.CREATE_DOCUMENTS);
